import React from 'react';
import {inject, observer} from "mobx-react";
import {AxlCheckbox, AxlInput, AxlPanel, AxlReselect} from 'axl-reactjs-ui';
import styles from './styles';
import {Box, Typography} from "@material-ui/core";
import usstates from "../../../../../constants/usstates.json";


const stateSelectData = usstates.map((option) => ({
    label: option.name,
    value: option.abbreviation,
}))


const ClientInfo = (props) => {

    const {userStore, insuranceStore} = props;
    const {claimForm} = insuranceStore;
    const {client} = userStore;
    const currentState = stateSelectData.find((usState) => usState.value === claimForm.getField('address.state', ''));

    const onSelectState = (selectState) => {
        const {insuranceStore} = props;
        const {claimForm} = insuranceStore;
        claimForm.setField('address.state', selectState ? selectState.value : '');
    }

    const onCheckBoxChange = (e) => {
        const {insuranceStore} = props;
        const {claimForm} = insuranceStore;
        const isChecked = claimForm.getField('saveAddressForFutureClaims', false);

        claimForm.setField('saveAddressForFutureClaims', !isChecked);
    }

    return (
        <AxlPanel>
            <AxlPanel.Row style={styles.row}>
                <AxlPanel.Col style={styles.col}>
                    <Typography style={styles.label}>{`Please review the client's information`}</Typography>
                </AxlPanel.Col>
            </AxlPanel.Row>
            <AxlPanel style={styles.Panel}>
                <AxlPanel.Row style={styles.LogoRow}>
                    <AxlPanel.Col style={styles.LogoCol}>
                        {client && client.logo_url &&
                            <Box width={32}>
                                <img src={`${client.logo_url}`} style={styles.logo}/>
                            </Box>
                        }
                    </AxlPanel.Col>
                </AxlPanel.Row>
                <AxlPanel.Row style={styles.Row}>
                    <AxlPanel.Col style={styles.Col}>
                        <Typography style={styles.label}>{`Company Name`}</Typography>
                        <AxlInput value={claimForm.getField('payeeFullName', '')} onChange={claimForm.handlerInput}
                                  name={`payeeFullName`}
                                  error={claimForm.getValidationError('payeeFullName')}
                                  type={`text`} fluid/>
                    </AxlPanel.Col>
                </AxlPanel.Row>
                <AxlPanel.Row style={styles.Row}>
                    <AxlPanel.Col style={styles.Col}>
                        <Typography style={styles.label}>{`Address Line 1 (house or building number and street name`}</Typography>
                        <AxlInput value={claimForm.getField('address.street', '')} onChange={claimForm.handlerInput}
                                  name={`address.street`}
                                  error={claimForm.getValidationError('address.street')}
                                  type={`text`} fluid/>
                    </AxlPanel.Col>
                </AxlPanel.Row>
                <AxlPanel.Row style={styles.Row}>
                    <AxlPanel.Col style={styles.Col}>
                        <Typography style={styles.label} >{`Address Line 2 (unit or apartment information)`}</Typography>
                        <AxlInput value={claimForm.getField('address.street2', '')} onChange={claimForm.handlerInput}
                                  name={`address.street2`} type={`text`}
                                  error={claimForm.getValidationError('address.street2')}
                                  fluid/>
                    </AxlPanel.Col>
                </AxlPanel.Row>
                <AxlPanel.Row style={styles.Row}>
                    <AxlPanel.Col style={styles.Col}>
                        <Typography style={styles.label}>{`City`}</Typography>
                        <AxlInput value={claimForm.getField('address.city', '')} onChange={claimForm.handlerInput}
                                  name={`address.city`} type={`text`}
                                  error={claimForm.getValidationError('address.city')}
                                  fluid/>
                    </AxlPanel.Col>
                    <AxlPanel.Col style={styles.Col}>
                        <Typography style={styles.label}>{`State`}</Typography>
                        <AxlReselect value={currentState} onChange={onSelectState} name={`address.state`}
                                     placeholder={'Select State'} theme={`main`} options={stateSelectData}
                                     error={claimForm.getValidationError('address.state')} isClearable/>
                    </AxlPanel.Col>
                    <AxlPanel.Col style={styles.Col}>
                        <Typography style={styles.label}>{`Zipcode`}</Typography>
                        <AxlInput value={claimForm.getField('address.zipcode', '')} onChange={claimForm.handlerInput}
                                  name={`address.zipcode`} type={`text`}
                                  error={claimForm.getValidationError('address.zipcode')} fluid/>
                    </AxlPanel.Col>

                </AxlPanel.Row>
                <AxlPanel.Row style={styles.checkboxRow}>
                    <AxlPanel.Col>
                        <AxlCheckbox
                            name={`saveAddressForFutureClaims`}
                            checked={claimForm.getField('saveAddressForFutureClaims', false)}
                            theme={`main`}
                            color={`white`}
                            onChange={onCheckBoxChange}
                            style={styles.checkbox}
                        >Save information for Future Claims</AxlCheckbox>
                    </AxlPanel.Col>
                </AxlPanel.Row>
            </AxlPanel>
        </AxlPanel>
    );
}

export default inject("userStore", "insuranceStore")(observer(ClientInfo));

